import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';

import { InvoicesComponent } from './invoices.component';
import { CreateInvoiceDialogComponent } from '@components/dialog/create-invoice-dialog/create-invoice-dialog.component';
import { PrintInvoiceDialogComponent } from '@components/dialog/print-invoice-dialog/print-invoice-dialog.component';
import { EditInvoiceSettingsDialogComponent } from '@components/dialog/edit-invoice-settings-dialog/edit-invoice-settings-dialog.component';
import { PayoutStatementsDialogComponent } from '@components/dialog/payout-statements-dialog/payout-statements-dialog.component';
import { CreditStatementsDialogComponent } from '@components/dialog/credit-statements-dialog/credit-statements-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'invoices',
          component: InvoicesComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {roles: ['Operator', 'Customer', 'User']},
          children: [
            {
              path: 'create/:key',
              component: CreateInvoiceDialogComponent,
              data: {roles: ['Customer']},
            },
            {
              path: 'print/:key',
              component: PrintInvoiceDialogComponent,
              data: {roles: ['Customer', 'User']},
            },
            {
              path: 'settings',
              component: EditInvoiceSettingsDialogComponent,
              data: {roles: ['Customer']},
            },
            {
              path: 'payout-statements',
              component: PayoutStatementsDialogComponent,
              data: {roles: ['Operator', 'Customer']},
            },
            {
              path: 'credit-statements',
              component: CreditStatementsDialogComponent,
              data: {roles: ['Operator', 'Customer']},
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class InvoicesModule { }
